import { useContext, useEffect, useState } from "react";
import homeStyle from "./Home.module.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { GlobalContext } from "../../context/Context";
import { homepage } from "../../Api/services";
import config, { baseURL } from "../../Api/config";
import { FaCheck } from "react-icons/fa";
import "keen-slider/keen-slider.min.css";
import { useKeenSlider } from "keen-slider/react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import ReactPlayer from "react-player";
import parse from "html-react-parser";
import { IoStar } from "react-icons/io5";
import Marquee from "react-fast-marquee";
import { Modal } from "antd";

const Home = (props) => {
  const [homepageDetails, setHomepageDetails] = useState(null);
  const [whyUsStrength, setWhyUsStrength] = useState({});
  const [whyUsPointers, setWhyUsPointers] = useState([]);
  const [itemTypes, setItemTypes] = useState([]);
  const [companyGroup, setCompanyGroup] = useState([]);
  const [galleryVideo, setGalleryVideo] = useState([]);
  var colorIndex = 0;
  const [homePageCustomerAndProduct, setHomePageCustomerAndProduct] = useState(
    {}
  );
  const [homePageDropDown, setHomePageDropDown] = useState([]);
  const [openDropDown, setOpenDropDown] = useState(-1);
  const [isToggled, setIsToggled] = useState(false);
  const navigate = useNavigate();
  const { user, setUser } = useContext(GlobalContext);
  const [isLoading, setIsLoading] = useState(true);
  const [companyGroupBanner, setCompanyGroupBanner] = useState([]);
  const [customerAndProductImages, setCustomerAndProductImages] = useState([]);
  const [homePageImageAndDescription, setHomePageImageAndDescription] =
    useState([]);
  const [youtubeSectionBackgroundImage, setYoutubeSectionBackgroundImage] =
    useState({});
  const [homePagePurpose, setHomePagePurpose] = useState([]);
  // Added by - Ashlekh on 11-04-2025
  // Reason - UseState to store marquee text
  const [marqueeText, setMarqueeText] = useState("");
  // End of code - Ashlekh on 11-04-2025
  // Reason - UseState to store marquee text
  // Added by - Ashlekh on 17-04-2025
  // Reason - UseState to store Home Page Governing Bodies
  const [homePageGoverningBodies, setHomePageGoverningBodies] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  // End of code - Ashlekh on 17-04-2025
  // Reason - UseState to store Home Page Governing Bodies
  // Added by - Ashlekh on 23-04-2025
  // Reason - useState to store home page executive committee body
  const [homePageExecutiveCommitteeBody, setHomePageExecutiveCommitteeBody] =
    useState([]);
  // End of code - Ashlekh on 23-04-2025
  // Reason - useState to store home page executive committee body
  const [isExecutiveCommitteeModalOpen, setIsExecutiveCommitteeModalOpen] =
    useState(false);
  const [executiveCommittee, setExecutiveCommittee] = useState(null);
  var colors = [
    "#227fbb",
    "#1aaf5d",
    "#8f3faf",
    "#2b3e51",
    "#00a185",
    "#f2c500",
  ];

  const getColor = () => {
    if (colorIndex < 6) {
      var color = colors[colorIndex];
      colorIndex++;
      return color;
    } else {
      colorIndex = 0;
      var color = colors[colorIndex];
      colorIndex++;

      return color;
    }
  };

  const [sliderRef, instanceRef] = useKeenSlider({
    breakpoints: {
      "(min-width: 0px)": {
        slides: { perView: 1, spacing: 5 },
      },
      "(min-width: 250px)": {
        slides: { perView: 2, spacing: 10 },
      },
      "(min-width: 300px)": {
        slides: { perView: 2, spacing: 40 },
      },
      "(min-width:350px)": {
        slides: { perView: 3, spacing: 10 },
      },
      "(min-width: 450px)": {
        slides: { perView: 4, spacing: 5 },
      },
      "(min-width: 800px)": {
        slides: { perView: 5, spacing: 10 },
      },
      "(min-width: 1000px)": {
        slides: { perView: 6, spacing: 10 },
      },
      "(min-width: 1200px)": {
        slides: { perView: 7, spacing: 5 },
      },
      "(min-width: 1400px)": {
        slides: { perView: 8, spacing: 5 },
      },
    },
    slides: { perView: 2 },
    loop: true,
  });

  const fetchData = async () => {
    try {
      const response = await homepage();
      setHomepageDetails(response.homepage_details);
      setWhyUsStrength(response.why_us_strength);
      setWhyUsPointers(response.why_us_pointers);
      setItemTypes(response.item_types);
      setCompanyGroup(response?.company_group);
      setGalleryVideo(response?.gallery_video);
      setHomePageCustomerAndProduct(response?.home_page_customer_and_product);
      setHomePageDropDown(response?.home_page_drop_down);
      setCompanyGroupBanner(response?.home_page_link_image);
      const customerAndProductImageArray = [
        response?.home_page_customer_and_product?.image,
        response?.home_page_customer_and_product?.image2,
        response?.home_page_customer_and_product?.image3,
        response?.home_page_customer_and_product?.image4,
        response?.home_page_customer_and_product?.image5,
      ].filter((img) => img);
      setCustomerAndProductImages(customerAndProductImageArray);
      setHomePageImageAndDescription(response?.home_page_image_and_description);
      setYoutubeSectionBackgroundImage(response?.setting_details);
      // Added by - Ashlekh on 11-04-2025
      // Reason - To set home page purpose details in useState
      setHomePagePurpose(response?.home_page_purpose);
      // End of code - Ashlekh on 11-04-2025
      // Reason - To set home page purpose details in useState
      // Added by - Ashlekh on 11-04-2025
      // Reason - To store marquee text
      setMarqueeText(response?.setting_details?.marquee_text);
      // End of code - Ashlekh on 11-04-2025
      // Reason - To store marquee text
      // Added by - Ashlekh on 17-04-2025
      // Reason - To store home page governing bodies
      setHomePageGoverningBodies(response?.home_page_governing_bodies);
      // End of code - Ashlekh on 17-04-2025
      // Reason - To store home page governing bodies
      // Added by - Ashlekh on 23-04-2025
      // Reason - To set data in homePageExecutiveCommitteeBody
      setHomePageExecutiveCommitteeBody(
        response?.home_page_executive_committee_body
      );
      // End of code - Ashlekh on 23-04-2025
      // Reason - To set data in homePageExecutiveCommitteeBody
    } catch (error) {
      console.error("Error fetching homepage details:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchData();
  }, []);

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 2,
      slidesToSlide: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1201 },
      items: 3,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 1200, min: 1101 },
      items: 3,
      slidesToSlide: 2,
    },
    tablet2: {
      breakpoint: { max: 1100, min: 901 },
      items: 2,
      slidesToSlide: 2,
    },
    tablet3: {
      breakpoint: { max: 900, min: 721 },
      items: 2,
      slidesToSlide: 2,
    },
    mobile: {
      breakpoint: { max: 720, min: 601 },
      items: 2,
      slidesToSlide: 1,
    },
    mobile2: {
      breakpoint: { max: 600, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };
  const toggleAnswer = (index) => {
    if (openDropDown === index) {
      setIsToggled(!isToggled);
      setOpenDropDown(null);
    } else {
      setOpenDropDown(index);
      setIsToggled(true);
    }
  };
  useEffect(() => {
    const interval = setInterval(() => {
      instanceRef.current?.next();
    }, 3000);

    return () => clearInterval(interval);
  }, [instanceRef]);
  const responsive2 = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
      slidesToSlide: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1201 },
      items: 1,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 1200, min: 1101 },
      items: 1,
      slidesToSlide: 1,
    },
    tablet2: {
      breakpoint: { max: 1100, min: 901 },
      items: 1,
      slidesToSlide: 1,
    },
    tablet3: {
      breakpoint: { max: 900, min: 721 },
      items: 1,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 720, min: 601 },
      items: 1,
      slidesToSlide: 1,
    },
    mobile2: {
      breakpoint: { max: 600, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };
  const responsiveCustomerAndProductImages = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
      slidesToSlide: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 721 },
      items: 1,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 720, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  const isMobile = () => window.innerWidth <= 768;
  const [mobileView, setMobileView] = useState(isMobile());

  useEffect(() => {
    const handleResize = () => setMobileView(isMobile());
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const showModal = (item) => {
    setSelectedItem(item);
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setSelectedItem(null);
  };
  const showExecutiveCommitteeModal = (item) => {
    setExecutiveCommittee(item);
    setIsExecutiveCommitteeModalOpen(true);
  };

  const handleExecutiveCommitteeModalCancel = () => {
    setIsExecutiveCommitteeModalOpen(false);
    setExecutiveCommittee(null);
  };

  const governingBodiesResponsive = {
    // superLargeDesktop: {
    //   // the naming can be any, depends on you.
    //   breakpoint: { max: 4000, min: 3000 },
    //   items: 5
    // },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
      slidesToSlide: 1,
    },
    tablet2: {
      breakpoint: { max: 1124, min: 873 },
      items: 3,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 872, min: 465 },
      items: 2,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  const getTrimmedDetail = (text) => {
    if (!text) return "";
    const isMobile = window.innerWidth < 900;
    const sliceLength = isMobile ? 60 : 80;
    return text?.length > sliceLength
      ? text?.slice(0, sliceLength) + "..."
      : text;
  };

  return (
    <>
      {isLoading ? (
        <div className={homeStyle.loaderContent}>
          <img style={{ height: "30vh" }} src="adyant_loader.gif" />
        </div>
      ) : (
        <div className={homeStyle.mainContainer}>
          {homepageDetails?.length > 0 ? (
            <Carousel
              responsive={responsive2}
              className={`${homeStyle.homePageBannerImageAndVideo}`}
              showDots={homepageDetails?.length > 1 ? true : false}
              // autoPlay={!isPaused}
              // Code changed by - Ashlekh on 06-02-2025
              // Reason - To add condition for arrow & autorotate
              // autoPlay={true}
              // infinite={true}
              arrows={homepageDetails?.length > 1}
              autoPlay={homepageDetails?.length > 1}
              infinite={homepageDetails?.length > 1}
              // End of code - Ashlekh on 06-02-2025
              // Reason - To add condition for arrow & autorotate
              autoPlaySpeed={4000}
            >
              {homepageDetails?.map((item, index) => (
                <div key={index}>
                  {/\.(mp4|mkv|webm|avi|mov|flv|wmv)$/i.test(
                    item.banner_video_file
                  ) ? (
                    <video
                      autoPlay
                      muted
                      loop
                      className={homeStyle.banner_video}
                    >
                      <source
                        src={`${baseURL}${item.banner_video_file}`}
                        type={`video/${item.banner_video_file
                          .split(".")
                          .pop()}`}
                      />
                      Your browser does not support the video tag.
                    </video>
                  ) : (
                    <img
                      src={`${baseURL}${item.banner_video_file}`}
                      alt={`Banner ${index + 1}`}
                      className={homeStyle.banner_image}
                    />
                  )}
                </div>
              ))}
            </Carousel>
          ) : null}
          {/* Added by - Ashlekh on 11-04-2025
          Reason - To display Marquee text */}
          {marqueeText?.length > 0 && (
            <div className={`${homeStyle.marqueeTextContainer}`}>
              <Marquee>
                <span className={`${homeStyle.marqueeTextGradient}`}>
                  {marqueeText}
                </span>
              </Marquee>
            </div>
          )}
          {/* End of code - Ashlekh on 11-04-2025
          Reason - To display Marquee text */}
          {/* Added by - Ashlekh on 11-04-2025
          Reason - To display sion And Vision */}
          {/* Changed by - Yogen on 19-06-2025
          Reason - To remove the Mission And Vision section */}
          {/* {homePagePurpose?.length > 0 && (
            <div className={`${homeStyle.missionVisionTitle}`}>
              {" "}
              Mission And Vision{" "}
            </div>
          )}
          <div className={`${homeStyle.homePagePurposeContainer}`}>
            {homePagePurpose?.map((item, index) => (
              <div
                key={index}
                className={`${homeStyle.homePagePurposeSubContainer}`}
              >
                <div
                  className={`${homeStyle.homePagePurposeBackgroundImageContainer}`}
                  style={{
                    backgroundImage:
                      "url(" + baseURL + item.background_image + ")",
                  }}
                >
                  <div className={`${homeStyle.homePagePurposeTitle}`}>
                    {item?.title}
                  </div>
                </div>
                <div className={`${homeStyle.homePagePurposeIconContainer}`}>
                  <img
                    src={`${config.baseURL + item?.icon}`}
                    className={`${homeStyle.homePagePurposeIcon}`}
                  />
                </div>
                <div className={`${homeStyle.homePagePurposeDescription}`}>
                  {item.description}
                </div>
              </div>
            ))}
          </div> */}
          {/* End of code - Yogen on 19-06-2025
          Reason - To remove the Mission And Vision section */}
          {/* End of code - Ashlekh on 11-04-2025
          Reason - To display Mission And Vision */}

          {/* Changed by - Yogen on 19-06-2025
          Reason - To remove dropdown and its description section for replacing*/}
          {/* <div className={`${homeStyle.customerAndProduct}`}>
            {homePageCustomerAndProduct.title ||
            homePageCustomerAndProduct?.title?.trim()?.length > 0 ? (
              <div className={`${homeStyle.customerAndProductTitle}`}></div>
            ) : null}
            <div className={`${homeStyle.customerAndProductContainer}`}>
              <div className={`${homeStyle.customerAndProductSubContainer}`}>
                <div className={`${homeStyle.homePageImageSlider}`}>
                  <Carousel
                    responsive={responsiveCustomerAndProductImages}
                    arrows={true}
                  >
                    {customerAndProductImages?.map((image, index) => {
                      return (
                        <div key={index}>
                          <img
                            className={`${homeStyle.customerAndProductImage}`}
                            src={config.baseURL + image}
                            alt=""
                          />
                        </div>
                      );
                    })}
                  </Carousel>
                </div>
                <div className={`${homeStyle.descriptionContainer}`}>
                  {parse(homePageCustomerAndProduct?.description)}
                </div>
              </div>

              <div className={`${homeStyle.dropDownContainer}`}>
                {homePageDropDown?.map((item, index) => (
                  <div
                    key={index}
                    className={`${homeStyle.dropDownSubContainer}`}
                  >
                    <div className={`${homeStyle.titleContainer}`}>
                      <div
                        className={`${homeStyle.dropdownTitle}`}
                        onClick={() => toggleAnswer(index)}
                      >
                        <div
                          className={`${homeStyle.titleSubContainer} ${
                            openDropDown === index && isToggled
                              ? homeStyle.active
                              : homeStyle.inactive
                          }`}
                        >
                          <div> {item.title} </div>
                          <div className={`${homeStyle.iconContainer}`}>
                            {openDropDown === index ? "-" : "+"}
                          </div>
                        </div>
                      </div>
                    </div>
                    {openDropDown === index && (
                      <div
                        className={`${homeStyle.dropDownDescriptionContainer}`}
                      >
                        <img
                          className={`${homeStyle.dropDownDescriptionImage}`}
                          // src={
                          //   item?.image
                          //     ? `${config.baseURL + item?.image}`
                          //     : "/homepage_dropdown_1.jpeg"
                          // }
                          src={`${config.baseURL + item?.image}`}
                          alt=""
                        />
                        <div className={`${homeStyle.dropDownDescription}`}>
                          {/* {item?.description} */}
                          {/* {parse(item?.description)}
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div> */} 
          {/* End of code - Yogen on 19-06-2025
          Reason - To remove dropdown and its description section for replacing*/}
          {/* Added By - Yogen on 18/06/2025
            Reason - To show change the image and description before show as dropdown */}
          <div className={homeStyle.page}>
            {homePageDropDown.map((item, index) => (
              <div
                key={index}
                className={homeStyle.wrapper}
              >
                {/* {item?.title} */}
                <h2 className={homeStyle.title}>{item?.title}</h2>
                { item?.image ? (
                <img
                  src={config.baseURL + item?.image}
                  className={
                    index % 2 !== 0
                      ? homeStyle.revImgContainer
                      : homeStyle.imgContainer
                  }
                  alt=""
                />
                ) : null
              }
                <div className={homeStyle.textbox}>
                  {parse(item?.description)}
                </div>
              </div>
            ))}
          </div>
          {/* Ended By - Yogen on 18/06/2025
            Reason : To show change the image and description before show as dropdown */}

          {companyGroup?.length > 0 ? (
            <div className={`${homeStyle.companyGroup}`}>
              <div className={`${homeStyle.title}`}>9M GROUP OF COMPANY</div>
              <div className={`${homeStyle.imageContainer}`}>
                {companyGroup.map((item, index) => (
                  <div key={index} className={`${homeStyle.imageSubContainer}`}>
                    <img
                      className={`${homeStyle.image}`}
                      src={config.baseURL + item?.image}
                      alt=""
                    />
                  </div>
                ))}
              </div>
            </div>
          ) : null}
          {companyGroupBanner?.length > 0 ? (
            <div className={`${homeStyle.companyGroupBannerContainer}`}>
              <Carousel responsive={responsive2}>
                {companyGroupBanner?.map((item, index) => {
                  return item?.link || item?.link?.trim()?.length > 0 ? (
                    <Link
                      style={{ display: "block" }}
                      to={item?.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      key={index}
                    >
                      <img
                        className={`${homeStyle.companyGroupBanner}`}
                        src={config.baseURL + item?.image}
                        alt=""
                      />
                    </Link>
                  ) : (
                    <img
                      key={index}
                      className={`${homeStyle.companyGroupBanner}`}
                      src={config.baseURL + item?.image}
                      alt=""
                    />
                  );
                })}
              </Carousel>
            </div>
          ) : null}
          {homePageImageAndDescription?.map((item, index) => {
            return (
              <div
                key={index}
                style={{
                  backgroundImage:
                    "url(" + baseURL + item.background_image + ")",
                }}
                className={`${homeStyle.homePageImageAndDescriptionContainer}`}
              >
                {window.innerWidth >= 720 ? (
                  <div
                    className={`${homeStyle.homePageImageAndDescriptionSubContainer}`}
                  >
                    {item?.image && (
                      <img
                        className={`${homeStyle.homePageImage}`}
                        src={config.baseURL + item?.image}
                        alt=""
                        style={{ order: index % 2 === 0 ? 0 : 1 }}
                      />
                    )}
                    <div
                      className={`${homeStyle.homePageDescription}`}
                      style={{ order: index % 2 === 0 ? 1 : 0 }}
                    >
                      {parse(item?.description)}
                    </div>
                  </div>
                ) : (
                  <div
                    className={`${homeStyle.homePageImageAndDescriptionSubContainer}`}
                  >
                    {item?.image && (
                      <img
                        className={`${homeStyle.homePageImage}`}
                        src={config.baseURL + item?.image}
                        alt=""
                      />
                    )}
                    <div className={`${homeStyle.homePageDescription}`}>
                      {parse(item?.description)}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
          {/* Added by - Ashlekh on 17-04-2025
          Reason - To show details of HomePageGoverningBodies */}
          {homePageGoverningBodies?.length > 0 && (
            <div className={`${homeStyle.governingBodiesTitle}`}>
              Governing Bodies
            </div>
          )}
          {/* {homePageGoverningBodies?.map((item, index) => {
            return (
              <div
                key={index}
                // style={{
                //   backgroundImage:
                //     "url(" + baseURL + item.background_image + ")",
                // }}
                className={`${homeStyle.homePageGoverningBodiesImageAndDescriptionContainer}`}
              >
                {window.innerWidth >= 720 ? (
                  <div
                    className={`${homeStyle.homePageGoverningBodiesImageAndDescriptionSubContainer}`}
                  >
                    <img
                      className={`${homeStyle.homePageGoverningBodiesImage}`}
                      src={config.baseURL + item?.image}
                      alt=""
                      style={{ order: index % 2 == 0 ? 0 : 1 }}
                    />
                    <div
                      className={`${homeStyle.homePageGoverningBodiesDescriptionContainer}`}
                      style={{ order: index % 2 == 0 ? 1 : 0 }}
                    >
                      <div className={`${homeStyle.governingBodiesName}`}>
                        {item?.name}
                      </div>
                      <div
                        className={`${homeStyle.governingBodiesDesignation}`}
                      >
                        {item?.designation}
                      </div>
                      <div
                        className={`${homeStyle.homePageGoverningBodiesDescription}`}
                      >
                        {parse(
                          item?.detail?.slice(0, 200) +
                            (item?.detail?.length > 200 ? "..." : "")
                        )}
                      </div>
                      {item?.detail && (
                        <div className={`${homeStyle.readMoreContainer}`}>
                          <div
                            className={`${homeStyle.readMore}`}
                            onClick={() => showModal(item)}
                          >
                            Read More
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <div
                    className={`${homeStyle.homePageGoverningBodiesImageAndDescriptionSubContainer}`}
                  >
                    <img
                      className={`${homeStyle.homePageGoverningBodiesImage}`}
                      src={config.baseURL + item?.image}
                      alt=""
                    />
                    <div
                      className={`${homeStyle.homePageGoverningBodiesDescriptionContainer}`}
                    >
                      <div
                        className={`${homeStyle.homePageGoverningBodiesDescription}`}
                      >
                        {parse(
                          item?.detail?.slice(0, 200) +
                            (item?.detail?.length > 200 ? "..." : "")
                        )}
                      </div>
                      {item?.detail && (
                        <div className={`${homeStyle.readMoreContainer}`}>
                          <div
                            className={`${homeStyle.readMore}`}
                            onClick={() => showModal(item)}
                          >
                            Read More
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            );
          })} */}
          {homePageGoverningBodies?.length > 0 && (
            <div className={`${homeStyle.governingBodiesParentContainer}`}>
              <Carousel responsive={governingBodiesResponsive}>
                {homePageGoverningBodies?.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className={`${homeStyle.governingBodiesContainer}`}
                    >
                      <div
                        // className={`${homeStyle.governingBodiesSubContainer} ${
                        //   index % 2 == 0 ? homeStyle.even : homeStyle.odd
                        // }`}
                        className={`${homeStyle.governingBodiesSubContainer} ${
                          index % 4 === 0
                            ? homeStyle.first
                            : index % 4 === 1
                            ? homeStyle.second
                            : index % 4 === 2
                            ? homeStyle.third
                            : homeStyle.fourth
                        }`}
                      >
                        <div
                          className={`${homeStyle.governingBodiesCarouselContainer}`}
                        >
                          <img
                            className={`${homeStyle.governingBodiesCarouselImage}`}
                            // src={`${config.baseURL}${item.image}`}
                            src={
                              item.image != null &&
                              item.image.trim() != "" &&
                              item?.image?.length > 1
                                ? `${config.baseURL}${item.image}`
                                : `${``}`
                            }
                            alt=""
                          />
                        </div>
                        <div
                          className={`${homeStyle.memberNameAndDesignation} ${homeStyle.governingBodiesName}`}
                        >
                          {item?.name?.length > 30
                            ? item?.name?.slice(0, 30) + "..."
                            : item?.name}
                        </div>
                        <div
                          className={`${homeStyle.memberNameAndDesignation} ${homeStyle.governingBodiesDesignation}`}
                        >
                          {item?.designation?.length > 30
                            ? item?.designation?.slice(0, 30) + "..."
                            : item?.designation}
                        </div>
                        {/* {item?.detail && (
                          <div className={`${homeStyle.readMoreContainer}`}>
                            <div
                              className={`${homeStyle.readMore}`}
                              onClick={() => showModal(item)}
                            >
                              Read More
                            </div>
                          </div>
                        )} */}
                        {item?.detail && (
                          <>
                            <div className={homeStyle.detailText}>
                              {parse(getTrimmedDetail(item?.detail))}
                            </div>
                            <div
                              className={`${homeStyle.readMoreClickableContainer}`}
                            >
                              <span
                                className={homeStyle.readMoreClickable}
                                onClick={() => showModal(item)}
                              >
                                Read more
                              </span>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  );
                })}
              </Carousel>
            </div>
          )}
          <Modal
            open={isModalOpen}
            onCancel={handleCancel}
            footer={null}
            centered
          >
            {selectedItem && (
              <div
                className={`${homeStyle.governingBodiesImageAndDescriptionContainer}`}
              >
                <img
                  src={config.baseURL + selectedItem.image}
                  alt=""
                  className={`${homeStyle.governingBodiesImage}`}
                />
                <div className={`${homeStyle.governingBodiesName}`}>
                  {selectedItem?.name}
                </div>
                <div className={`${homeStyle.governingBodiesDesignation}`}>
                  {selectedItem?.designation}
                </div>
                {selectedItem?.registration_number != null &&
                  selectedItem?.registration_number?.trim()?.length > 0 && (
                    <div className={`${homeStyle.registrationNumber}`}>
                      Registration Number : {selectedItem?.registration_number}
                    </div>
                  )}
                <div>{parse(selectedItem?.detail)}</div>
              </div>
            )}
          </Modal>
          {/* End of code - Ashlekh on 17-04-2025
          Reason - To show details of HomePageGoverningBodies */}
          {/* Added by - Ashlekh on 23-04-2025
          Reason - To show home page executive committee body */}
          {homePageExecutiveCommitteeBody?.length > 0 && (
            <div className={`${homeStyle.homePageExecutiveCommitteeBodyTitle}`}>
              Executive Committee
            </div>
          )}
          {homePageExecutiveCommitteeBody?.length > 0 ? (
            <div
              className={`${homeStyle.homePageExecutiveCommitteeBodyContainer}`}
            >
              {homePageExecutiveCommitteeBody?.map((item, index) => (
                <div
                  key={index}
                  className={`${homeStyle.homePageExecutiveCommitteeBodySubContainer}`}
                >
                  <img
                    className={`${homeStyle.homePageExecutiveCommitteeBodyImage}`}
                    src={config?.baseURL + item?.image}
                    alt=""
                  />
                  <div
                    className={`${homeStyle.homePageExecutiveCommitteeBodyMemberName}`}
                  >
                    {item?.name?.length > 20
                      ? item?.name.slice(0, 20) + "..."
                      : item?.name}
                  </div>
                  <div
                    className={`${homeStyle.homePageExecutiveCommitteeBodyOccupation}`}
                  >
                    Ward:{" "}
                    {item?.post_ward?.length > 20
                      ? item?.post_ward.slice(0, 20) + "..."
                      : item?.post_ward}
                  </div>
                  <div className={`${homeStyle.viewMoreButtonContainer}`}>
                    <div
                      className={`${homeStyle.viewMoreButton}`}
                      onClick={() => showExecutiveCommitteeModal(item)}
                    >
                      View more
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : null}
          <Modal
            open={isExecutiveCommitteeModalOpen}
            onCancel={handleExecutiveCommitteeModalCancel}
            footer={null}
            centered
          >
            {executiveCommittee && (
              <div
                className={`${homeStyle.governingBodiesImageAndDescriptionContainer}`}
              >
                <img
                  src={config.baseURL + executiveCommittee.image}
                  alt=""
                  className={`${homeStyle.governingBodiesImage}`}
                />
                <div className={`${homeStyle.governingBodiesName}`}>
                  {executiveCommittee?.name}
                </div>
                <div className={`${homeStyle.governingBodiesDesignation}`}>
                  Ward: {executiveCommittee?.post_ward}
                </div>
                {/* <div>{parse(executiveCommittee?.description)}</div> */}
                <div>
                  {typeof executiveCommittee?.description === "string"
                    ? parse(executiveCommittee?.description)
                    : null}
                </div>
              </div>
            )}
          </Modal>
          {/* End of code - Ashlekh on 23-04-2025
          Reason - To show home page executive committee body */}
          {galleryVideo?.length > 0 && (
            <div
              className={`${homeStyle.videoContainer}`}
              style={{
                backgroundImage:
                  "url(" +
                  baseURL +
                  youtubeSectionBackgroundImage.home_page_youtube_section_background_image +
                  ")",
              }}
            >
              <div className={`${homeStyle.videoTitle}`}>Featured Videos</div>
              <div className={`${homeStyle.videoSubTitle}`}>
                Stay Updated with latest events and activites
              </div>
              <div className={`${homeStyle.videoSubContainer}`}>
                <Carousel responsive={responsive}>
                  {galleryVideo?.map((item, index) => {
                    return (
                      <div key={index}>
                        <ReactPlayer
                          className={`${homeStyle.video}`}
                          url={item?.video}
                          controls={true}
                          // width={290}
                          // height={175}
                          width={330}
                          height={200}
                        />
                      </div>
                    );
                  })}
                </Carousel>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default Home;
